import { Level, LogHandler, Logger } from 'simple-logging-lib';
import { PLATFORM_LOGGER } from '../../../config';
import { useRef } from 'react';
export class NCErrorHandler extends LogHandler {
  constructor(onError) {
    super();
    this.level = Level.ERROR;
    this.isLoggable = ({
      level
    }) => level === Level.ERROR;
    this.onError = onError;
  }
  publish(record) {
    if (!this.isLoggable(record)) {
      return;
    }
    const {
      loggerName,
      messages
    } = record;
    console.error(`%c[${loggerName}]`, 'color: #444; font-weight: bold;', ...messages);
    if (this.onError) {
      this.onError(messages[0]);
    }
  }
}
export const useSetupPlatformLogger = onError => {
  const errorHandler = useRef(new NCErrorHandler(onError)).current;
  const logger = Logger.getLogger(PLATFORM_LOGGER);
  logger.setLevel(Level.ERROR);
  const hdlrs = logger.getHandlers();
  if (hdlrs.size === 0) {
    logger.addHandler(errorHandler);
  }
  return logger;
};